import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-network-error-disconnected',
    template: require('./network.error.disconnected.component.html'),
})

export class NetworkErrorDisconnectedComponent {

    constructor(@Inject(MatDialogRef<NetworkErrorDisconnectedComponent>) public dialogRef: MatDialogRef<NetworkErrorDisconnectedComponent>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value);
    }

}


